<template>
  <b-container fluid class="px-2">
    <table class="table">
      <tr v-for="model in availableModels">
        <td>  
          {{ $t(model) }}
        </td>
        <td>
          <template v-if="modelStatus(model) == 'completed'">
            <div class="d-flex flex-column btn-container">
              <b-btn size="sm" variant="success">
                Analysis done
              </b-btn>
              <b-btn size="sm" variant="info" @click="resetProjectAnalysis(model)">
                Reset
              </b-btn>
            </div>
          </template>
          <template v-else-if="(modelStatus(model) == 'in_progress' || modelStatus(model) == 'in_queue')">
            <b-btn size="sm" variant="secondary" >
              Analysis in progress
            </b-btn>
          </template>
          <template v-else>
            <b-btn size="sm" variant="warning" @click.prevent="sendForAnalysis(model)" :disabled="loading">
              Start
            </b-btn>
          </template>
        </td>
      </tr>
    </table>
  </b-container>
</template>

<script>
  import { ProjectMixin } from '@/mixins';
  import { mapGetters } from 'vuex';
  export default {
      name: "SelectEquipmentDrawer",
      mixins:[ProjectMixin],
      data: () => ({
        loading: false
      }),
      computed: {
        ...mapGetters({
          projectAnalysis: "projectAnalysis/items",
          availableModels: "projectAnalysis/availableModels"
        }),

        
      },

      methods: {
        modelStatus(model){
          return (this.projectAnalysis.filter(pa => pa.model_title == model)[0] || {}).status
        },

        sendForAnalysis(model){
          if(confirm("Are you sure to start analysis?")){
            this.$store.dispatch('projectAnalysis/create', { 
              projectId: this.projectId,
              payload: {
                project_analysis: {
                  model_title: model
                }
              },
            }).then(res => {
            })
          }
        },

        resetProjectAnalysis(model){
          if(confirm(this.$t('warnings.reset_project_analysis'))){
            this.$store.dispatch('projectAnalysis/reset', {
              projectId: this.projectId,
              payload: {
                project_analysis: {
                  model_title: model
                }
              },
            })
          }
        }
      }
  }
</script>
<style scoped>
  .btn-container{
    gap: 10px;
  }
</style>
